import './config';
import init from '@/shared/init';
import i18n from '@/shared/i18n';
import store from '@/shared/store';
import router from './router';
import layouts from './layouts';
import plugins from './plugins';

init({ layouts, options: { i18n, router, store }, plugins });
